import { useState } from "react";
import { Button } from "@/components/ui/Button";
import { downloadEmployeeTimesExport } from "@/lib/employeeTimes";
import { toast } from "@/lib/toast";

interface TimesExportButtonProps {
  employeeLogin: string;
  year: number;
  month?: number;
  includeHero?: boolean;
  disabled?: boolean;
  className?: string;
}

export function TimesExportButton({
  employeeLogin,
  year,
  month,
  includeHero = false,
  disabled = false,
  className,
}: TimesExportButtonProps) {
  const [busy, setBusy] = useState(false);

  async function handleExport() {
    if (!employeeLogin) return;
    setBusy(true);
    try {
      await downloadEmployeeTimesExport({
        user_login: employeeLogin,
        year,
        month,
        include_hero: includeHero,
      });
    } catch (err) {
      toast.error(
        err instanceof Error ? err.message : "Excel-Export konnte nicht erstellt werden.",
      );
    } finally {
      setBusy(false);
    }
  }

  return (
    <Button
      type="button"
      variant="secondary"
      className={className}
      disabled={disabled || busy || !employeeLogin}
      onClick={() => void handleExport()}
    >
      {busy ? "Export…" : "Excel-Export"}
    </Button>
  );
}
